<template>
  <div>
    <v-row>
      <v-col
        xs='12'
        sm='6'
      >
        <div
          class='px-2 py-4 warehouseCard'
        >
          <v-row>
            <v-col cols='1'>
              <div class='warehouseCard__icon-block'>
                <img class='warehouseCard__icon' src='@/assets/icons/svg/warehouse.svg'>
              </div>
            </v-col>
            <v-col cols='11'>
              <div>
                <p
                  style='font-size: 1rem; color: #000000;'
                  class='mb-0'
                >
                  <b>{{warehouseInfo.name}}</b>
                </p>
              </div>
              <div>
                <p style='font-size: 0.9rem' class='mb-0'>{{warehouseInfo.description}}</p>
              </div>
              <v-divider class='mt-2' />
              <v-row class='mt-2 mb-0 flex justify-end' style='max-height: 45px'>
                <v-col cols='auto' style='max-height: 45px; box-sizing: border-box' class='py-0 flex'>
                  <p style='display: block;' class='mb-0 text-uppercase text-grey-6 text-center'>folders: </p>
                  <p style='display: block;' class='mb-0 ml-1 text-uppercase text-center'><b>{{warehouseInfo.info.countCategories}}</b></p>
                </v-col>
                <v-col cols='auto' style='max-height: 45px; box-sizing: border-box' class='py-0 flex'>
                  <p style='display: block;' class='mb-0 text-uppercase text-grey-6 text-center'>items: </p>
                  <p style='display: block;' class='mb-0 ml-1 text-uppercase text-center'><b>{{warehouseInfo.info.countItems}}</b></p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
        <v-checkbox
          v-model='clearInventory'
          label="Clear inventory"
          color="#8074c2"
          class='mt-6'
        />
      </v-col>
      <v-col
        xs='12'
        sm='6'
      >
        <div
          class='px-2 py-4 mx-2 warehouseCard'
        >
          <v-row>
            <v-col cols='auto'>
              <v-img
                :lazy-src='$publicPath + "/static/src/images/integration-logos/integration_qbo.svg"'
                :src='$publicPath + "/static/src/images/integration-logos/integration_qbo.svg"'
                max-width='130'
                max-height='130'
              />
            </v-col>
            <v-col>
              <p class='text-grey-7'>Online accounting software. It allows users to create, <br />store and send invoices from any device.</p>
            </v-col>
          </v-row>
          <v-divider class='mt-2' />
          <v-row v-if='systemInfo' class='mt-2 mb-0 flex justify-end' style='max-height: 45px'>
            <v-col cols='auto' style='max-height: 45px; box-sizing: border-box' class='py-0 flex'>
              <p style='display: block;' class='mb-0 text-uppercase text-grey-6 text-center'>folders: </p>
              <p style='display: block;' class='mb-0 ml-1 text-uppercase text-center'><b>{{systemInfo.countCategories}}</b></p>
            </v-col>
            <v-col cols='auto' style='max-height: 45px; box-sizing: border-box' class='py-0 flex'>
              <p style='display: block;' class='mb-0 text-uppercase text-grey-6 text-center'>items: </p>
              <p style='display: block;' class='mb-0 ml-1 text-uppercase text-center'><b>{{systemInfo.countItems}}</b></p>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
    <div v-if='!inSync'>
      <v-row class='mt-6'>
        <v-col class='flex justify-center'>
          <h6 class='font-weight-bold'>Click the button below to complete sync with QuickBooks:</h6>
        </v-col>
      </v-row>
      <v-row class='mt-4'>
        <v-col class='flex justify-center'>
          <v-btn
            color='#7972c0'
            depressed
            @click='$emit("doSync", clearInventory)'
          >
            <span class='text-white'>
              Sync Now
            </span>
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <v-row class='mt-6'>
        <v-col class='flex justify-center'>
          <h6 class='font-weight-bold'>Synchronization in progress...</h6>
        </v-col>
      </v-row>
      <v-row class='mt-4'>
        <v-col class='flex justify-center'>
          <div class='relative-position mb-6' style='height: 48px'>
            <custom-circle-progress-bar />
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CustomCircleProgressBar from '@/components/CustomCircleProgressBar'
export default {
  name: 'syncStep3',
  props: {
    warehouse: {
      required: true
    },
    inSync: {
      type: Boolean,
      required: true
    },
    systemInfo: {
      required: true,
      type: [Boolean, Object]
    }
  },
  data: () => ({
    clearInventory: false
  }),
  computed: {
    ...mapGetters('warehouses', {
      warehousesList: 'getWarehousesList'
    }),
    warehouseInfo() {
      if (this.warehouse?.id) return this.warehousesList.find(item => item.id === this.warehouse.id)
      return {}
    }
  },
  async created() {
    this.$store.dispatch('warehouses/loadWarehousesList')
  },
  components: {
    CustomCircleProgressBar
  }
}
</script>

<style src='@/styles/base/integrations.scss' scoped lang='scss'></style>
